module.exports = __webpack_public_path__ + "img/clock.e32736d3.svg";